import { Button, Skeleton, DatePicker, Card, Spin } from "antd";
import React, { useEffect, useRef, useState } from "react";
import * as echarts from 'echarts';
import * as XLSX from "xlsx";
import { useStoreUpdaterWithAPI } from "../../../../../Hooks/UseStoreUpdaterWithApi";
import { useSelector } from "react-redux";
import { APIConstants } from "../../../../../Common/APIConstants";
import CustomDrawer from "../../../../Elements/CustomDrawer";
import CustomSelect from "../../../../Elements/CustomSelect";
import TreeSelectCustomWithSelectAll from "../../../Electrical/Charts/LiveModule/LiveTrends/LineChart/TreeSelectCustomWithAllSelect";
import TreeSelectCustom from "../../../Electrical/Charts/LiveModule/LiveTrends/LineChart/TreeSelectCustom";
import { generatedISOFormatDateString } from "../../../../../Utils/DateConverstion";




const AirHistoricalTrends = () => {
  const chartRef = useRef(null);  
  const {loading,  makeRequest } = useStoreUpdaterWithAPI();
  const [sectionId, setSectionId] = useState();
  const [converterGroupId, setConverterGroupId] = useState();
  const [selectedMeterIds, setSelectedMeterIds] = useState([]); 
  const [selectedValues, setSelectedValues] = useState([]);
  const [skip, setSkip] = useState(true);
  const [open, setOpen] = useState(false); 
  const [fromDateObj, setFromDateObj] = useState(null);
  const [fromDateString, setFromDateString] = useState();
  const [toDateObj, setToDateObj] = useState(null);
  const [toDateString, setToDateString] = useState(); 
  const [chartSkip, setChartSkip] = useState(true);

  const [sectionError, setSectionError] = useState();
  const [converterError, setConverterError] = useState();
  const [meterError, setMeterError] = useState();
  const [paraError, setParaError] = useState();
  const [fromDateError, setFromDateError] = useState();
  const [toDateError, setToDateError] = useState();
  const [chartLoading, setChartLoading] = useState(false);
  const [flowSectionResData, setflowSectionResData] = useState([]);
  const [getFlowConverterResData, setgetFlowConverterResData] = useState([]);
  const [flowGroupDetailsResData, setflowGroupDetailsResData] = useState([]);
  const [nsGetFlowConverterResData, setnsGetFlowConverterResData] = useState([]);
  const [getFlowSteamGroupMeterResData, setgetFlowSteamGroupMeterResData] = useState([]);

  const [steamHistoricalData,setsteamHistoricalData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  // const [parameter,setParameter]=useState([]);
  const [data1,setData1]= useState([]);
  const [data2,setData2]= useState([]);
  const [data3,setData3]= useState([]);
  const [parameterLenght, setParameterLenght] = useState('')
  const defaultParameters = ['kWhImport','KWT','IAVG','VLLAvg'];
  const [loadings, setLoadings] = useState(true);
  const simulateLoading = (setLoadings) => {
    setLoadings(true);
    setTimeout(() => {
      setLoadings(false);
    }, 2000); // 2 seconds
  };
  useEffect(()=>{
    simulateLoading(setLoadings);
  },[])


  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;

  useEffect(()=>{
    makeRequest({ 
        type: APIConstants.GET, 
        url: `${APIConstants.GET_FLOW_SECTION_MASTER_DETAILS}`
      }).then((res) => {
        console.log(res)
        setflowSectionResData(res);
      });

    makeRequest({ 
        type: APIConstants.GET, 
        url: `${APIConstants.GET_FLOW_CONVERTER_DETAILS}`
      }).then((res) => {
        console.log(res)
        setgetFlowConverterResData(res);
      });

    makeRequest({  
       type: APIConstants.POST,
       url: `${APIConstants.ELECTRICAL_GROUP_NAME}?Module=1`
      }).then((res) => {
        console.log(res)
        setflowGroupDetailsResData(res);
      });
      // makeRequest({  
      //   type: APIConstants.GET, 
      //   url: `${APIConstants.ELECTRICAL_PARAMETER_DETAILS}`
      // }).then((res) => {
      //   console.log(res)
      //   setParameter(res);
      // });
   
  },[])

  const parameter = [
    { parameterid: 1, parametername: "flowRate" },
    { parameterid: 2, parametername: "cumulative" },
  ];

  useEffect(()=>{
    makeRequest({ 
        type: APIConstants.GET,  
        url: `${APIConstants.GET_FLOW_NS_CONVERTER_DETAILS}?ConverterID=${converterGroupId}` 
      }).then((res) => {
        console.log(res) 
        setnsGetFlowConverterResData(res);
      });

    makeRequest({ 
        type: APIConstants.POST,  
        url: `${APIConstants.GET_FLOW_STEAM_GROUP_METER_DETAILS}?GroupID=${converterGroupId}&Module=1`
      }).then((res) => {
        console.log(res)
        setgetFlowSteamGroupMeterResData(res);
      });
  },[converterGroupId])
 
  

// function prepareLineChartData(data, excludeFields = ["sitename", "meterid", "createdON", "metername"]) {
//   const series = [];
//   const xAxisData = [];
//   const metrics = {};
//   const parameters=[];
//   console.log(selectedValues)
  
//   console.log(data)
  
//   function removeDuplicates(inputArray) {
//     console.log(inputArray)
//     const seen = new Set();
//     const result = [];
    
//     inputArray.forEach(item => {
//       if (!seen.has(item)) {
//         result.push(item); 
//         seen.add(item);
//       }
//     });
     
//     return result;
//   }

//   data.forEach((entry) => {
//       // Add unique timestamps to x-axis  
//       if (!xAxisData.includes(entry.createdON.replace("T", " "))) {
//           xAxisData.push(entry.createdON.replace("T", " ")); 
//       } 

//       // Iterate through all fields in the entry
//       for (const key in entry) {
//           if (!excludeFields.includes(key)) {
//               // Group by METERNAME and metric (e.g., KWHTotal)
//               const metricKey = `${entry.metername}-${key}`;
//               if (!metrics[metricKey]) {
//                   metrics[metricKey] = [];
//               }
//               metrics[metricKey].push(entry[key]);
//               parameters.push(key);

//           }
//       }
//   });

//   // Prepare series for ECharts
//   for (const [metricName, values] of Object.entries(metrics)) {
//       series.push({
//           name: metricName,
//           type: 'line',
//           data: values, 
//       });
//   }
//   const para = removeDuplicates(parameters);
//   console.log(para);
//   console.log(xAxisData);
//   const uniqueTimestamps = Array.from(
//     new Set(xAxisData.map(ts => {
//       const [date, time] = ts.split(' '); // Split date and time
//       const timeWithoutSeconds = time.split(':').slice(0, 2).join(':'); // Keep hour and minute
//       return `${date} ${timeWithoutSeconds}:00`; // Append :00 for seconds
//     }))
//   );

//   console.log(uniqueTimestamps)
//   // Return the chart configuration
//   console.log(series)

//   return {
//       xAxisData:uniqueTimestamps,
//       series: series,
//       parameter:para
//   };
// }

function prepareLineChartData(data, excludeFields = ["sitename", "meterid", "createdON", "metername"]) {
  const series = [];
  const xAxisData = [];
  const metrics = {};
  const parameters = [];
  // const selectedValues=selectedValues

  console.log(data)
  function removeDuplicates(inputArray) {
    const seen = new Set();
    const result = [];
    inputArray.forEach(item => {
      if (!seen.has(item)) {
        result.push(item);
        seen.add(item);
      }
    });
    return result;
  }

  data.forEach((entry) => {
    // Add unique timestamps to x-axis
    const normalizedTimestamp = entry.createdON.replace("T", " ").split(':').slice(0, 2).join(':') + ":00";
    if (!xAxisData.includes(normalizedTimestamp)) {
      xAxisData.push(normalizedTimestamp);
    }

    // Iterate through all fields in the entry
    for (const key in entry) {
      if (!excludeFields.includes(key)) {
        // Only process keys present in selectedValues
        if (selectedValues.includes(key)) {
          const metricKey = `${entry.metername}-${key}`;
          if (!metrics[metricKey]) {
            metrics[metricKey] = [];
          }
          metrics[metricKey].push(entry[key]);
          parameters.push(key);
        }
      }
    }
  });

  // Prepare series for ECharts
  for (const [metricName, values] of Object.entries(metrics)) {
    series.push({
      name: metricName,
      type: 'line',
      data: values,
    });
  }

  const para = removeDuplicates(parameters);
  const uniqueTimestamps = Array.from(new Set(xAxisData));
  console.log(para)
  console.log(series)

  return {
    xAxisData: uniqueTimestamps,  
    series: series,
    parameter: para
  };
}


  
  const getResponse =(inputData)=>{
    console.log(inputData);
    setIsLoading(true);
    
    makeRequest({ 
        type: APIConstants.GET,   
        // url: `${APIConstants.GET_AIR_HISTORICAL_DATA }?SectionID=${inputData.SectionID}&ConverterorGroupID=${inputData.ConverterorGroupID}&MeterIds=${inputData.MeterIds}&FromDate=${inputData.FromDate}&ToDate=${inputData.ToDate}` 
        url: `${APIConstants.GET_AIR_HISTORICAL_DATA }?SectionID=${inputData.SectionID}&ConverterorGroupID=${inputData.ConverterorGroupID}&MeterIds=${inputData.MeterIds}&FromDate=2023-10-01%2001%3A16%3A00&Todate=2023-10-01%2002%3A16%3A00` 
        // url: `${APIConstants.GET_AIR_HISTORICAL_DATA}?SectionID=1&ConverterorGroupID=21&MeterIds=75%2C76%2C77&FromDate=2023-10-01%2001%3A16%3A00&Todate=2023-10-01%2002%3A16%3A00` 
      }).then((res) => {
        console.log(res)
        setsteamHistoricalData(res);
        if (res&&res.length>0) {    
          const test =prepareLineChartData(res)
          console.log(test)
          setData1(test.xAxisData)
          setData2(test.series)
        }
        setIsLoading(false);
      });
  }
 
  const getFlowSectionList = (flowSectionResData && flowSectionResData) || [];
  const getFlowConverterList =
    (getFlowConverterResData && getFlowConverterResData) || [];
  const flowGroupDetailsList =
    (flowGroupDetailsResData && flowGroupDetailsResData) || [];
  const nsGetFlowConverterList =
    (nsGetFlowConverterResData && nsGetFlowConverterResData) || [];
  const getFlowSteamGroupMeterList =
    (getFlowSteamGroupMeterResData && getFlowSteamGroupMeterResData) || [];

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    // After 1 second, set skipValue to false
    const timeoutId = setTimeout(() => {
      setSkip(false);
    }, 3000);

    // Clear the timeout if the component unmounts or skipValue is set to false
    return () => clearTimeout(timeoutId);
  }, []);

  const handleChangeSection = (changedValues) => {
    setSectionId(changedValues);
    setSelectedMeterIds();
    if (changedValues) {
      setSectionError("");
    }
  };

  const handleChangeConverterGroup = (changedValues) => {
    setConverterGroupId(changedValues);
    setSelectedMeterIds();
    if (changedValues) {
      setConverterError("");
    }
  };

  const handleMeterChange = (selectedValues) => {
    setSelectedMeterIds(selectedValues);
    if (selectedValues) {
      setMeterError("");
    }
  };

  const handleTreeChange = (values) => {
    setSelectedValues(values);
    if (values.length>4) {
      console.log(values);
      setParameterLenght('Cannot select more than 4 values');
    }else{
      setParameterLenght('');
    }
    if (values) {
      setParaError("");
    }
  };

  const setChartInputData = () => {
    const ids = selectedMeterIds?.map((id) => id).join(",");
    const para = selectedValues?.map((id) => id).join(",");
    console.log(para)

    const fromDate = new Date(fromDateString || new Date());
    const toDate = new Date(toDateString || new Date());

    const formattedFromDate = generatedISOFormatDateString(fromDate);
    const formattedToDate = generatedISOFormatDateString(toDate);

    const inputData = {
      SectionID: Number(sectionId) || 1,
      ConverterorGroupID: Number(converterGroupId) || 1,
      Parameters:para||0,
      MeterIds: ids || [1],
      FromDate: formattedFromDate,
      ToDate: formattedToDate,
    };
    console.log(inputData)
    getResponse(inputData);
  };

  useEffect(() => {
    setChartInputData();
  },[]);
 
  useEffect(() => {
    setChartSkip(!chartSkip);
    updateChart();
  },[steamHistoricalData]);
 
  const validateInput = (value, label) => {
    const error = !value ? `Please Select ${label}` : "";
    return error;
  };

  const handleSubmit = () => {
    const sectionError = validateInput(sectionId, "Section");
    const converterError = validateInput(converterGroupId, "Converter");
    const meterError = validateInput(selectedMeterIds.length, "Meter");
    const paraError = validateInput(selectedValues.length, "Parameter");
    const fromDateError = validateInput(fromDateString, "From Date");
    const toDateError = validateInput(toDateString, "To Date");

    setSectionError(sectionError); 
    setConverterError(converterError);
    setMeterError(meterError);
    setParaError(paraError);
    setFromDateError(fromDateError);
    setToDateError(toDateError);

    if (
      !sectionError &&
      !converterError &&
      !meterError &&
      !paraError &&
      !fromDateError &&
      !toDateError 
      // && !parameterLenght
    ) {
      onClose();
      setChartLoading(true);
      setChartInputData();
      
      setIsLoading(true); 
    }
  };

  const onChangeFromDate = (date, dateString) => {
    setFromDateString(dateString);
    setFromDateObj(date);
    if (dateString) {
      setFromDateError("");
    }
  };

  const onChangeToDate = (date, dateString) => {
    setToDateString(dateString);
    setToDateObj(date);
    if (dateString) {
      setToDateError("");
    }
  };

  const updateChart = async () => { 
    try {
      setChartLoading(true);
  
      // Filter steamHistoricalData based on selected meter IDs
      const selectedMeterData = steamHistoricalData?.filter((item) =>
        selectedMeterIds?.map((id) => Number(id)).includes(item?.meterid)
      );
      console.log(steamHistoricalData)
      console.log(selectedMeterIds)
  
      // Transform the data in a chart series format
      console.log(selectedMeterData)
      const transformData = (parameterName, meterName) => {
        console.log(parameterName)
        const data = selectedMeterData
          ?.filter((item) => item?.sitename === meterName)
          ?.map((item) => item[parameterName]);
        return {
          name: `${parameterName}-${meterName}`,
          data,
        };
      };
  
      const seriesData = [];
      console.log(selectedValues)
      console.log(nsGetFlowConverterList)
  
      // Iterate over selected meter IDs and selectedValues properties
      selectedMeterIds?.forEach((id) => {
        const meterName = sectionId === 1
          ? nsGetFlowConverterList?.find((item) => item?.meterid === Number(id))?.metername
          : getFlowSteamGroupMeterList?.find((item) => item?.meterID === Number(id))?.meterName;
          console.log(meterName)
  
        selectedValues.forEach((parametername ) => {
          seriesData.push(transformData(parametername, meterName));
        });
      });

      console.log(selectedValues)
      console.log(seriesData)
  
      const datesArray = [];
      const dateProperty = "createdON";
      
      selectedMeterIds?.forEach((id) => {
        const meterName = sectionId === 1
          ? nsGetFlowConverterList?.find((item) => item?.meterid === Number(id))?.metername
          : getFlowSteamGroupMeterList?.find((item) => item?.meterID === Number(id))?.meterName;
          
        datesArray.push(transformData(dateProperty, meterName));
      });
      console.log(datesArray)
  
      // Filter to include only selected parameter names in selectedValues
      const finalData = seriesData.filter((series) => 
        selectedValues.some(({ parametername }) => series.name.includes(parametername))
      );
  
      // Find the longest date array and reverse it
      const reversedDate = datesArray.reduce((largest, current) => {
        if (!largest || current.data.length > largest.data.length) {
          return { ...current, data: [...current.data].reverse() };
        }
        return largest;
      }, null);
      console.log(finalData)
  
      const reversedFinalData = finalData.map((data) => ({
        data: data.data.reverse(),
        name: data.name,
      }));
  
      // Format dates for x-axis
      const localDateTime = reversedDate?.data?.map((date) =>
        new Date(date).toLocaleString("en-US")
      );
      console.log(reversedFinalData)
  
      // setData1(reversedFinalData);
      // setData2(localDateTime);
  
      setChartLoading(false);
    } catch (err) {
      console.error(err);
      setChartLoading(false);
    }
  };

  const exportToExcel = (data) => {
    // Transform the data into a tabular format
    const headers = ["S. No.", ...data.map((item) => item.name)];
    const rows = Array.from({ length: data[0].data.length }, (_, i) => [
      ` ${i + 1}`,
      ...data.map((item) => item.data[i]),
    ]);
  
    const excelData = [headers, ...rows];
  
    // Create a new workbook and worksheet
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet(excelData);
  
    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "EnergyData");
  
    // Generate a filename with the current date and time in local timezone
    const now = new Date();
    const timestamp = now
      .toLocaleString("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false, // Use 24-hour format
      })
      .replace(/[/,: ]/g, "-"); // Replace unwanted characters for a filename
  
    const filename = `Historical_Trends_${timestamp}.xlsx`;
  
    console.log("Generated Filename: ", filename);
  
    
    XLSX.writeFile(workbook, filename);
  };
  
    //  useEffect(() => {
    //     if (selectedValues.length === 0) {
    //       setSelectedValues(defaultParameters); 
    //     }
    //   }, [selectedValues]);
  
  useEffect(() => {
    if (loading || !data1 || !data2) return; // Prevent chart rendering if loading or data is unavailable
  
    console.log(data1);
    console.log(data2);
  
    const myChart = echarts.init(chartRef.current);
  
    const option = { 
      backgroundColor: isdarkMode ? '#2d3748' : '#fff',
      title: {
        text: `Historical Trends`,
        left: 'center',
        top: '5px',
        textStyle: {
          color: isdarkMode ? 'white' : 'black',
        },
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
        confine: true, 
        position: function (point, params, dom, rect, size) {
          // `point` is the mouse position, `[x, y]`
          // `size` contains the size of the tooltip
          const [x, y] = point;
          const { contentSize, viewSize } = size; // Size of the tooltip and view
      
          let xPos = x + 10; // Add some padding
          let yPos = y + 10;
      
          // Prevent overflow on the right
          if (xPos + contentSize[0] > viewSize[0]) {
            xPos -= contentSize[0] + 20; // Move it left
          }
      
          // Prevent overflow on the bottom
          if (yPos + contentSize[1] > viewSize[1]) {
            yPos -= contentSize[1] + 1000; // Move it up
          }
      
          return [xPos, yPos];
        },
      },
      
      legend: {
        bottom: '0px',
        textStyle: {
          color: isdarkMode ? 'white' : 'black',
        },
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '25%', 
        containLabel: true,
      },
      toolbox: {
        show: true,
        orient: 'horizontal',
        left: 'right',
        top: 'top',
        feature: {
          myExport: {
            show: true,
            title: "Export to Excel",
            icon: "path://M5 0L15 10L5 20Z", 
            onclick: () => {
              exportToExcel(data2);
            },
          },
          mark: { show: true },
          magicType: { show: true, type: ['line', 'bar'] },
          saveAsImage: { show: true },
        },
        iconStyle: {
          borderColor: isdarkMode ? 'white' : 'black',
        },
        emphasis: {
          iconStyle: {
            borderColor: isdarkMode ? '#FFD700' : '#1E90FF', 
          },
        },
      },
      xAxis: [
        {
          type: 'category',
          data: Array.from({ length: 8 }, (_, i) => `S. No.${i + 1}`), // Example categories
          axisTick: { show: false },
          data: data1,
          axisLabel: {
            color: isdarkMode ? 'white' : 'black',
            fontSize: '10',
            fontWeight: 'bold',
          },
        },
      ],
      yAxis: [
        {
          type: 'value',
          axisLabel: {
            color: isdarkMode ? 'white' : 'black',
            fontSize: '10',
            fontWeight: 'bold',
          },
        },
      ],
      series: data2,
      dataZoom: [
        {
          type: 'inside', // Enables zooming via scroll or pinch
          start: 0,
          end: 100,
        },
      ],
    };
    
  
    myChart.setOption(option);
  
    const resizeHandler = () => myChart.resize();
    window.addEventListener('resize', resizeHandler);
  
    return () => {
      window.removeEventListener('resize', resizeHandler);
      myChart.dispose();
    };
  }, [data1, data2, isdarkMode, loading]); // Include loading in dependencies
  

  return (
    <div id="chart" className={` relative bg-white p-4 rounded-md  dark ${isdarkMode ? 'darkmode' : 'whitemode'} `}>
      {/* {isLoading  &&(
        <div className="absolute inset-0 flex justify-center items-center bg-white dark:bg-gray-800 bg-opacity-75 dark:bg-opacity-75 z-10">
          <Spin active paragraph={{ rows: 6 }} />
        </div> 
      )} */}
     
      <Card 
        className={`p-4 rounded-md dark ${isdarkMode ? "darkmode" : "whitemode"} w-full lg:w-full md:w-11/12 sm:w-10/12 xs:w-11/12`}
        style={{ position: 'relative' }}
      >  
{
          !data1.length >0 && !loading &&
          <div className="text-3xl">
          <div className={`${!isdarkMode ? "text-black" : "text-white"}`}>No Data Available</div>
          </div> 
         } 
          {loading  && ( 
      <>
        <Skeleton active paragraph={{ rows: 6 }} />
      </> 
      )}
        <div ref={chartRef} className={`${(!loading||!loadings) && data1.length>0 ? 'min-h-[650px]':'h-0'}  w-[100%]  mx-auto rounded-lg  mb-0 md:mb-0 px-3`}/>

        </Card>


        
      <CustomDrawer
        title="Close"
        showDrawer={showDrawer}
        open={open}
        onClose={onClose}
      >
        <div className="flex flex-col space-y-2">
          <CustomSelect
            label="Section:"
            options={getFlowSectionList}
            onSelect={handleChangeSection}
            valueKey="sectionID"
            nameKey="sectionName"
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {sectionError}
          </small>
          <CustomSelect
            label="Converter / Group:"
            options={
              sectionId === 1 ? getFlowConverterList : flowGroupDetailsList
            }
            onSelect={handleChangeConverterGroup}
            valueKey={sectionId === 1 ? "sitE_ID" : "groupID"}
            nameKey={sectionId === 1 ? "sitename" : "department"}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {converterError}
          </small>
          <TreeSelectCustomWithSelectAll
            label="Meters:"
            data={
              sectionId === 1
                ? nsGetFlowConverterList
                : getFlowSteamGroupMeterList
            }
            idKey={sectionId === 1 ? "meterid" : "meterid"}
            valueKey={sectionId === 1 ? "meterid" : "meterid"}
            nameKey={sectionId === 1 ? "metername" : "metername"}
            selectedValues={selectedMeterIds}
            setSelectedValues={setSelectedMeterIds}
            onSelect={handleMeterChange}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {meterError}
          </small>
          <TreeSelectCustom
            label="Parameters:"
            data={parameter}
            idKey="id"        
            nameKey="name"     
            valueKey="name" 
            selectedValues={selectedValues}
            onSelect={handleTreeChange}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {paraError}
            {/* {parameterLenght} */}
          </small>
          <div className="mt-2 flex">
            <label className="pr-3 w-32 text-left">From Date:</label>
            <DatePicker
              value={fromDateObj}
              onChange={onChangeFromDate}
              className={`   ${isdarkMode ? 'datebackground' : 'whitemode'} w-80 `}
              dropdownClassName={isdarkMode ? 'datedropdown' : 'whitemode'}
              showTime={{ format: "HH:mm:ss" }}
              format="YYYY-MM-DD HH:mm:ss"
            />
          </div>
          <small className="text-red-500 font-bold ml-[150px]">
            {fromDateError}
          </small>
          <div className="mt-2 flex">
            <label className="pr-3 w-32 text-left">To Date:</label>
            <DatePicker
              value={toDateObj}
              onChange={onChangeToDate}
              className={`   ${isdarkMode ? 'datebackground' : 'whitemode'} w-80 `}
              dropdownClassName={isdarkMode ? 'datedropdown' : 'whitemode'}
              showTime={{ format: "HH:mm:ss" }}
              format="YYYY-MM-DD HH:mm:ss"
            />
          </div>
          <small className="text-red-500 font-bold ml-[150px]">
            {toDateError}
          </small>
        </div>
        <div className="flex justify-center mt-4">
          <Button
            className="blue-btn"
            onClick={() => {
              handleSubmit();
            }}
          >
            Search
          </Button> 
        </div>
      </CustomDrawer>
    </div>
  );
};

export default AirHistoricalTrends;

 

// const AirHistoricalTrends = () => {
//   const { loading, makeRequest } = useStoreUpdaterWithAPI();
//   const [sectionId, setSectionId] = useState();
//   const [converterGroupId, setConverterGroupId] = useState();
//   const [selectedMeterIds, setSelectedMeterIds] = useState([]);
//   const [selectedValues, setSelectedValues] = useState([]);
//   const [skip, setSkip] = useState(true);
//   const [open, setOpen] = useState(false);
//   const [fromDateObj, setFromDateObj] = useState(null);
//   const [fromDateString, setFromDateString] = useState();
//   const [toDateObj, setToDateObj] = useState(null);
//   const [toDateString, setToDateString] = useState();
//   const [chartSkip, setChartSkip] = useState(true);
//   const [chartInput, setChartInput] = useState(null);

//   const [sectionError, setSectionError] = useState();
//   const [converterError, setConverterError] = useState();
//   const [meterError, setMeterError] = useState();
//   const [paraError, setParaError] = useState();
//   const [fromDateError, setFromDateError] = useState();
//   const [toDateError, setToDateError] = useState();

//   const [chartLoading, setChartLoading] = useState(false);

//   const [flowSectionResData, setflowSectionResData] = useState([]);
//   const [getFlowConverterResData, setgetFlowConverterResData] = useState([]);
//   const [flowGroupDetailsResData, setflowGroupDetailsResData] = useState([]);
//   const [nsGetFlowConverterResData, setnsGetFlowConverterResData] = useState([]);
//   const [getFlowSteamGroupMeterResData, setgetFlowSteamGroupMeterResData] = useState([]);

//   const [steamHistoricalData,setsteamHistoricalData] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);


//   const mode = useSelector((state) => state.darkMode);

//   const { isdarkMode } = mode;



//   const [chartData, setChartData] = useState({
//     series: [],
//     options: {
//       chart: {
//         id: "historical-trends",
//         height: 350,
//         type: "line",
//         zoom: {
//           type: "x",
//           enabled: true,
//           // autoScaleYaxis: true,
//         },
//         toolbar: {
//           autoSelected: "zoom",
//         },
//       },
//       legend: {
//         show: true,
//         showForSingleSeries: true,
//         showForNullSeries: true,
//         showForZeroSeries: true,
//         position: 'bottom',
//         horizontalAlign: 'center', 
//         floating: false,
//         fontSize: '14px',
//         fontFamily: 'Helvetica, Arial',
//         fontWeight: 400,
//         formatter: undefined,
//         inverseOrder: false,
//         width: undefined,
//         height: undefined,
//         tooltipHoverFormatter: undefined,
//         customLegendItems: [],
//         offsetX: 0,
//         offsetY: 0,
//         labels: {
//             colors: undefined,
//             useSeriesColors: false
//         },
//         markers: {
//             width: 12,
//             height: 12,
//             strokeWidth: 0,
//             strokeColor: '#fff',
//             fillColors: undefined,
//             radius: 12,
//             customHTML: undefined,
//             onClick: undefined,
//             offsetX: 0,
//             offsetY: 0
//         },
//         itemMargin: {
//             horizontal: 5,
//             vertical: 10
//         },
//         onItemClick: {
//             toggleDataSeries: true
//         },
//         onItemHover: {
//             highlightDataSeries: false
//         },
//       },
//       dataLabels: {
//         enabled: false,
//       },
//       stroke: {
//         curve: "smooth",
//       },
//       markers: {
//         size: 5,
//         strokeOpacity: 0.3,
//         hover: {
//           size: undefined,
//           sizeOffset: 3,
//         },
//       },
//       title: {
//         // display: true,
//         text: "Historical Trends",
//         // color:  'red',

//         style: {
//    color: isdarkMode ? "#FFFFFF" : "#000000",
//               // className={`p-4 rounded-md dark ${isdarkMode ? "darkmode" : "whitemode"}`
//            fontSize: "18px", 
//            fontWeight: "bold" },
        
//       },
//       xaxis: {
//         categories: [],
//         labels: { 
//           style: { 
//             color: "red",
//           }
//         },
//         title: { 
//           text: "Date", 
//           style: {
//             color: isdarkMode ? "#FFFFFF" : "#000000",
//           }
//         }
//       },
//       yaxis: {
//         title: {
//           text: "Value",
//         },
//       },
//       // tooltip: {
//       //   y: [
//       //     {
//       //       title: {
//       //         formatter: function (val) {
//       //           return val + " (mins)";
//       //         },
//       //       },
//       //     },
//       //     {
//       //       title: {
//       //         formatter: function (val) {
//       //           return val + " per session";
//       //         },
//       //       },
//       //     },
//       //     {
//       //       title: {
//       //         formatter: function (val) {
//       //           return val + "Kg";
//       //         },
//       //       },
//       //     },
//       //   ],
//       // },
//       tooltip: {
//         x: {
//           show: true,
//           format: "dd-MMM",
//           formatter: undefined,
//         },
//         y: {
//           title: {
//             formatter: (
//               seriesName,
//               { series, seriesIndex, dataPointIndex, w }
//             ) => {
//               const isFlowRate = seriesName.includes("flowRate");
//               const kgLabel = isFlowRate ? " Kg/hr" : "Kg";

//               // Assuming opts.value contains the actual y-axis value
//               return seriesName + kgLabel;
//             },
//           },
//         },
//       },
//     },
//   });

//   const inputData = {
//     SectionID: 1,
//     ConverterorGroupID: 2,
//     MeterIds: "1",
//     FromDate: "2023-09-21T07:15:00.000Z",
//     ToDate: "2023-09-25T07:15:00.000Z",
//   };


//   useEffect(()=>{
//     makeRequest({ 
//         type: APIConstants.GET, 
//         // GetFlowSteamGropeMeterDetails?GroupID=81
//         url: `${APIConstants.GET_FLOW_SECTION_MASTER_DETAILS}`
//       }).then((res) => {
//         console.log(res)
//         setflowSectionResData(res);
//       });

//     makeRequest({ 
//         type: APIConstants.GET, 
//         // GetFlowSteamGropeMeterDetails?GroupID=81
//         url: `${APIConstants.GET_FLOW_CONVERTER_DETAILS}`
//       }).then((res) => {
//         console.log(res)
//         setgetFlowConverterResData(res);
//       });

//     makeRequest({  
//         type: APIConstants.GET, 
//         // GetFlowSteamGropeMeterDetails?GroupID=81
//         url: `${APIConstants.GET_STEAM_FLOW_GROUP_DETAILS}`
//       }).then((res) => {
//         console.log(res)
//         setflowGroupDetailsResData(res);
//       });

   
//   },[])

//   useEffect(()=>{
//     if(converterGroupId)
//  { 
//   makeRequest({ 
//     type: APIConstants.GET,  
//     // GetFlowSteamGropeMeterDetails?GroupID=81
//     url: `${APIConstants.GET_FLOW_NS_CONVERTER_DETAILS}?ConverterID=${converterGroupId}` 
//   }).then((res) => {
//     console.log(res) 
//     setnsGetFlowConverterResData(res);
//   });
//  }   

//     makeRequest({ 
//         type: APIConstants.GET,  
//         // GetFlowSteamGropeMeterDetails?GroupID=81
//         url: `${APIConstants.GET_FLOW_STEAM_GROUP_METER_DETAILS}?GroupID=${converterGroupId}` 
//       }).then((res) => {
//         console.log(res)
//         setgetFlowSteamGroupMeterResData(res);
//       });
//   },[converterGroupId])

  
//   const getResponse =(inputData)=>{
//     console.log(inputData)
    
//     makeRequest({ 
//         type: APIConstants.GET,  
//         // GetFlowSteamGropeMeterDetails?GroupID=81
//         // http://20.244.40.160:81/TVSDashBoard/GetsteamHistoricalDetails?SectionID=1&ConverterorGroupID=24&MeterIds=21,22,23&FromDate=2024-7-11T13:08:50.000Z&ToDate=2024-7-19T13:08:55.000Z
//         // url: `${APIConstants.GET_AIR_HISTORICAL_DATA }?SectionID=${inputData.SectionID}&ConverterorGroupID=${inputData.ConverterorGroupID}&MeterIds=${inputData.MeterIds}&FromDate=${inputData.FromDate}&ToDate=${inputData.ToDate}` 
//         url: `${APIConstants.GET_AIR_HISTORICAL_DATA}?SectionID=1&ConverterorGroupID=21&MeterIds=75%2C76%2C77&FromDate=2023-10-01%2001%3A16%3A00&Todate=2023-10-01%2002%3A16%3A00` 
//       }).then((res) => {
//         console.log(res)
//         setsteamHistoricalData(res);
//       });
//   }

//   const getFlowSectionList = (flowSectionResData && flowSectionResData) || [];
//   const getFlowConverterList =
//     (getFlowConverterResData && getFlowConverterResData) || [];
//   const flowGroupDetailsList =
//     (flowGroupDetailsResData && flowGroupDetailsResData) || [];
//   const nsGetFlowConverterList =
//     (nsGetFlowConverterResData && nsGetFlowConverterResData) || [];
//   const getFlowSteamGroupMeterList =
//     (getFlowSteamGroupMeterResData && getFlowSteamGroupMeterResData) || [];

//   const showDrawer = () => {
//     setOpen(true);
//   };

//   const onClose = () => {
//     setOpen(false);
//   };

//   useEffect(() => {
//     // After 1 second, set skipValue to false
//     const timeoutId = setTimeout(() => {
//       setSkip(false);
//     }, 3000);

//     // Clear the timeout if the component unmounts or skipValue is set to false
//     return () => clearTimeout(timeoutId);
//   }, []);

//   const handleChangeSection = (changedValues) => {
//     setSectionId(changedValues);
//     setSelectedMeterIds();
//     if (changedValues) {
//       setSectionError("");
//     }
//   };

//   const handleChangeConverterGroup = (changedValues) => {
//     setConverterGroupId(changedValues);
//     setSelectedMeterIds();
//     if (changedValues) {
//       setConverterError("");
//     }
//   };

//   const handleMeterChange = (selectedValues) => {
//     setSelectedMeterIds(selectedValues);
//     if (selectedValues) {
//       setMeterError("");
//     }
//   };

//   const handleTreeChange = (values) => {
//     setSelectedValues(values);
//     if (values) {
//       setParaError("");
//     }
//   };

//   const setChartInputData = () => {
//     const ids = selectedMeterIds?.map((id) => id).join(",");

//     const fromDate = new Date(fromDateString || new Date());
//     const toDate = new Date(toDateString || new Date());

//     const formattedFromDate = generatedISOFormatDateString(fromDate);
//     const formattedToDate = generatedISOFormatDateString(toDate);

//     const inputData = {
//       SectionID: Number(sectionId) || 1,
//       ConverterorGroupID: Number(converterGroupId) || 1,
//       MeterIds: ids || [1],
//       FromDate: formattedFromDate,
//       ToDate: formattedToDate,
//     };
//     getResponse(inputData)
//     // const queryString = objectToQueryString(inputData);
//     // setChartInput(queryString);
//   };

//   useEffect(() => {
//     setChartInputData();
//   }, []);

//   useEffect(() => {
//     setChartSkip(!chartSkip);
//     updateChart();
//   }, [steamHistoricalData]);
 
//   const validateInput = (value, label) => {
//     const error = !value ? `Please Select ${label}` : "";
//     return error;
//   };

//   const handleSubmit = () => {
//     const sectionError = validateInput(sectionId, "Section");
//     const converterError = validateInput(converterGroupId, "Converter");
//     const meterError = validateInput(selectedMeterIds.length, "Meter");
//     const paraError = validateInput(selectedValues.length, "Parameter");
//     const fromDateError = validateInput(fromDateString, "From Date");
//     const toDateError = validateInput(toDateString, "To Date");

//     setSectionError(sectionError); 
//     setConverterError(converterError);
//     setMeterError(meterError);
//     setParaError(paraError);
//     setFromDateError(fromDateError);
//     setToDateError(toDateError);

//     if (
//       !sectionError &&
//       !converterError &&
//       !meterError &&
//       !paraError &&
//       !fromDateError &&
//       !toDateError
//     ) {
//       onClose();
//       setChartLoading(true);
//       setChartInputData();
      
//       setIsLoading(false); 
//     }
//   };

//   const updateChart = async () => {
//     try {
//       setChartLoading(true);
//       const selectedMeterData = steamHistoricalData?.filter((item) =>
//         selectedMeterIds?.map((id) => Number(id)).includes(item?.meterid)
//       );
//       // transform the data in a chart series format
//       const transformData = (property, meterName) => {
//         const data = selectedMeterData
//           ?.filter((item) => item?.metername === meterName)
//           ?.map((item) => item[property]);
//         const seriesData = {
//           name: `${property}-${meterName}`, // Concatenate property and METERNAME
//           data,
//         };
//         return seriesData;
//       };
//       const properties = selectedValues;
//       const seriesData = [];

//       // Iterate over selected meter IDs and properties
//       selectedMeterIds?.forEach((id) => {
//         const meterName =
//           sectionId === 1
//             ? nsGetFlowConverterList?.find(
//                 (item) => item?.meterid === Number(id)
//               ).metername
//             : getFlowSteamGroupMeterList?.find(
//                 (item) => item?.meterID === Number(id)
//               ).meterName;
//         properties.forEach((property) => {
//           seriesData.push(transformData(property, meterName));
//         });
//       });

//       const datesArray = [];
//       const date = ["createdON"];
//       selectedMeterIds?.forEach((id) => {
//         const meterName =
//           sectionId === 1
//             ? nsGetFlowConverterList?.find(
//                 (item) => item?.meterid === Number(id)
//               ).metername
//             : getFlowSteamGroupMeterList?.find(
//                 (item) => item?.meterID === Number(id)
//               ).meterName;
//         date.forEach((property) => {
//           datesArray.push(transformData(property, meterName));
//         });
//       });
//       const firstOption = selectedValues.includes("flowRate");
//       const secondOption = selectedValues.includes("cumulative");
//       const finalData = seriesData?.filter((series) => {
//         if (firstOption && secondOption) {
//           // Both options selected, keep all series
//           return true;
//         } else if (firstOption) {
//           // First option selected, add series with "FlowRate"
//           return series.name.includes("flowRate");
//         } else if (secondOption) {
//           // Second option selected, add series with "Cumulative"
//           return series.name.includes("cumulative");
//         }
//         // If neither option selected, keep all series
//         return true;
//       });

//       const reversedDate = datesArray.reduce((largest, current) => {
//         if (!largest || current.data.length > largest.data.length) {
//           return { ...current, data: [...current.data].reverse() };
//         }
//         return largest;
//       }, null);

//       const reversedFinalData = finalData.map((data) => {
//         return { data: data.data.reverse(), name: data.name };
//       });

//       // // x axis input
//       const localDateTime = reversedDate?.data?.map((date) =>
//         new Date(date).toLocaleString("en-US")
//       );
//       // update in columnData
//       setChartData((prevChartData) => ({
//         series: reversedFinalData || [],
//         options: {
//           ...prevChartData.options,
//           xaxis: {
//             ...prevChartData.options.xaxis,
//             categories: localDateTime || [],
//           },
//         },
//       }));
//       setChartLoading(false);
//     } catch (err) {
//       console.log(err);
//       setChartLoading(false);
//     }
//   };

//   const onChangeFromDate = (date, dateString) => {
//     setFromDateString(dateString);
//     setFromDateObj(date);
//     if (dateString) {
//       setFromDateError("");
//     }
//   };

//   const onChangeToDate = (date, dateString) => {
//     setToDateString(dateString);
//     setToDateObj(date);
//     if (dateString) {
//       setToDateError("");
//     }
//   };

//   const parameters = [
//     { id: 1, name: "flowRate" },
//     { id: 2, name: "cumulative" },
//   ];

 

//   return (
//     <div id="chart" className={` relative bg-white p-4 rounded-md  dark ${isdarkMode ? 'darkmode' : 'whitemode'} `}>
//       {isLoading  &&(
//         <div className="absolute inset-0 flex justify-center items-center bg-white dark:bg-gray-800 bg-opacity-75 dark:bg-opacity-75 z-10">
//           <Spin active paragraph={{ rows: 6 }} />
//         </div>
//       )}

//       <Card
//         className={`p-4 rounded-md dark ${isdarkMode ? "darkmode" : "whitemode"} w-full lg:w-full md:w-11/12 sm:w-10/12 xs:w-11/12`}
//         style={{ position: 'relative', overflow: 'hidden' }}
//       >


//         <ReactApexChart
//           options={chartData.options}
//           series={chartData.series}
//           type="line"
//           height={500}
//           className="w-full"
//         />

//         </Card>


        
//       <CustomDrawer
//         title="Close"
//         showDrawer={showDrawer}
//         open={open}
//         onClose={onClose}
//       >
//         <div className="flex flex-col space-y-2">
//           <CustomSelect
//             label="Section:"
//             options={getFlowSectionList}
//             onSelect={handleChangeSection}
//             valueKey="sectionID"
//             nameKey="sectionName"
//           />
//           <small className="text-red-500 font-bold ml-[150px]">
//             {sectionError}
//           </small>
//           <CustomSelect
//             label="Converter / Group:"
//             options={
//               sectionId === 1 ? getFlowConverterList : flowGroupDetailsList
//             }
//             onSelect={handleChangeConverterGroup}
//             valueKey={sectionId === 1 ? "sitE_ID" : "groupID"}
//             nameKey={sectionId === 1 ? "sitename" : "groupName"}
//           />
//           <small className="text-red-500 font-bold ml-[150px]">
//             {converterError}
//           </small>
//           <TreeSelectCustomWithSelectAll
//             label="Meters:"
//             data={
//               sectionId === 1
//                 ? nsGetFlowConverterList
//                 : getFlowSteamGroupMeterList
//             }
//             idKey={sectionId === 1 ? "meterid" : "meterID"}
//             valueKey={sectionId === 1 ? "meterid" : "meterID"}
//             nameKey={sectionId === 1 ? "metername" : "meterName"}
//             selectedValues={selectedMeterIds}
//             setSelectedValues={setSelectedMeterIds}
//             onSelect={handleMeterChange}
//           />
//           <small className="text-red-500 font-bold ml-[150px]">
//             {meterError}
//           </small>
//           <TreeSelectCustom
//             label="Parameters:"
//             data={parameters}
//             idKey="id"        
//             nameKey="name"     
//             valueKey="name"
//             selectedValues={selectedValues}
//             onSelect={handleTreeChange}
//           />
//           <small className="text-red-500 font-bold ml-[150px]">
//             {paraError}
//           </small>
//           <div className="mt-2 flex">
//             <label className="pr-3 w-32 text-left">From Date:</label>
//             <DatePicker
//               value={fromDateObj}
//               onChange={onChangeFromDate}
//               className={`   ${isdarkMode ? 'datebackground' : 'whitemode'} w-80 `}
//               dropdownClassName={isdarkMode ? 'datedropdown' : 'whitemode'}
//               showTime={{ format: "HH:mm:ss" }}
//               format="YYYY-MM-DD HH:mm:ss"
//             />
//           </div>
//           <small className="text-red-500 font-bold ml-[150px]">
//             {fromDateError}
//           </small>
//           <div className="mt-2 flex">
//             <label className="pr-3 w-32 text-left">To Date:</label>
//             <DatePicker
//               value={toDateObj}
//               onChange={onChangeToDate}
//               className={`   ${isdarkMode ? 'datebackground' : 'whitemode'} w-80 `}
//               dropdownClassName={isdarkMode ? 'datedropdown' : 'whitemode'}
//               showTime={{ format: "HH:mm:ss" }}
//               format="YYYY-MM-DD HH:mm:ss"
//             />
//           </div>
//           <small className="text-red-500 font-bold ml-[150px]">
//             {toDateError}
//           </small>
//         </div>
//         <div className="flex justify-center mt-4">
//           <Button
//             className="blue-btn"
//             onClick={() => {
//               handleSubmit();
//             }}
//           >
//             Search
//           </Button> 
//         </div>
//       </CustomDrawer>
//     </div>
//   );
// }

// export default AirHistoricalTrends
